$ ->
  # Show/hide the add daybook entry form
  $('.daybook-sheet .btn-add, .new-daybook-entry .btn-cancel').on 'click', (e) ->
    e.preventDefault();
    $('.new-daybook-entry').fadeToggle();
